import { createFileRoute } from "@tanstack/react-router";
import { idSchema } from "@typedoc/contracts/ids";
import { z } from "zod";
import { membersSwitchSearch } from "../../../lib/connections/members-personal";

export const Route = createFileRoute("/_authenticated/_workspace/connections/")({
  // A connection the sign-in callback just completed; the list opens it as soon as it can.
  // `members` is the switch that widens the list to members' personal connections, kept in the
  // address so a reload and an opened account agree.
  validateSearch: z.object({
    finished: idSchema("connection").optional(),
    members: membersSwitchSearch,
  }),
  // Nothing is open, so the list takes the whole page.
  component: () => null,
});
